{
  "adminSignInLink": {
    "body": "اضغط على الزر أدناه للوصول إلى بوابة إدارة Pointcare الخاصة بك.",
    "cta": "تسجيل الدخول إلى الإدارة",
    "greeting": "مرحبًا،",
    "ignore": "إذا لم تطلب وصول الإدارة، يمكنك تجاهل هذه الرسالة.",
    "linkFallback": "إذا لم يعمل الزر، انسخ هذا الرابط والصقه:",
    "signoff": "شكرًا،\nفريق Pointcare",
    "subject": "رابط تسجيل الدخول لإدارة Pointcare الخاص بك"
  },
  "reset": {
    "body": "لقد تلقّينا طلبًا لإعادة تعيين كلمة مرور حسابك في Pointcare. اضغط على الزر أدناه لإنشاء كلمة مرور جديدة.",
    "cta": "إعادة تعيين كلمة المرور",
    "greeting": "مرحبًا،",
    "ignore": "إذا لم تطلب ذلك، يمكنك تجاهل هذه الرسالة بأمان. لن تتغيّر كلمة مرورك.",
    "signoff": "شكرًا،\nفريق Pointcare",
    "subject": "إعادة تعيين كلمة مرور Pointcare"
  },
  "signInLink": {
    "body": "اضغط على الزر أدناه لتأكيد بريدك الإلكتروني وإعداد حسابك في Pointcare.",
    "cta": "تأكيد بريدي الإلكتروني",
    "greeting": "مرحبًا،",
    "ignore": "ألم تسجّل في Pointcare؟ يمكنك تجاهل هذه الرسالة.",
    "linkFallback": "إذا لم يعمل الزر، انسخ هذا الرابط والصقه:",
    "signoff": "شكرًا،\nفريق Pointcare",
    "subject": "أكّد بريدك الإلكتروني لـ Pointcare"
  }
}
